/**
 * Created by slava on 02.02.17.
 */

const MultiColorCellView = BaseCellView.extend({
    ctor: function (multicolorCell) {
        this._super();

        this.setContentSize(cleverapps.styles.BaseCellView.CELL_SIZE_PX, cleverapps.styles.BaseCellView.CELL_SIZE_PX);
        this.setAnchorPoint(0.5, 0.5);

        this.animation = new cleverapps.Spine(bundles.game.jsons.multicolor_animation_json);
        this.animation.setPosition(this.width / 2, this.height / 2);
        this.addChild(this.animation);

        this.animation.setAnimation(0, "idle", true);

        this.initialize(multicolorCell);
    },
    
    initialize: function (multicolorCell) {
        this._super(multicolorCell);

        if (this.animation) {
            this.stopAllActions();
            this.animation.visible = true;
            this.animation.setAnimation(0, "idle", true);
            this.animation.setCompleteListener(); // wrong listener remains, need to clear
        }
    },
    
    createAnimation: function () {
        this.animation.visible = false;
        this.animation.setAnimation(0, "enter", false);
        this.animation.setCompleteListener(() => {
            this.animation.setAnimation(0, "idle", true);
        });
        cleverapps.effects.fire("match3.cell.combo.create");
    },

    startExploding: function () {
        if (!this.getParent()) {
            return;
        }
        this.stopAllActions();
        this.setLocalZOrder(100);
        const styles = cleverapps.styles.MultiColorCellView;

        let action = new cc.CallFunc(() => {
            this.animation.setAnimation(0, "exit", false);
            this.animation.setCompleteListener(() => {
                this.animation.setVisible(false);
                this.delete();
            });
        });

        if (styles.centerAnimation && !cleverapps.gameModes.newRules) {
            const gotoCenterAction = new cc.Spawn(
                new cc.MoveTo(styles.centerAnimation.duration, this.getParent().width / 2, this.getParent().height / 2),
                new cc.ScaleTo(styles.centerAnimation.duration, styles.centerAnimation.scale)
            );

            action = new cc.Sequence(gotoCenterAction, action);
        }

        this.runAction(action);

        if (Game.currentGame) {
            Game.currentGame.shakeField(styles.shakeField);
        }

        cleverapps.effects.fire("match3.multicolor.use");
    }
});

cleverapps.styles.MultiColorCellView = {
    shakeField: {
        delay: 400
    },

    centerAnimation: {
        duration: 0.25,
        scale: 2
    }
};